export default __webpack_public_path__ + "static/media/woman_with_phone.62579291.png";